// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__a234s","swiper":"Layout_swiper__goBSS","swiperSlide":"Layout_swiperSlide__wqE2X"};